import React from 'react'
import { List, Typography, Empty, Spin, Alert, Space, Badge, Statistic, Row, Col } from 'antd'
import { AppstoreOutlined, GroupOutlined, TagsOutlined } from '@ant-design/icons'
import { useFetchConceptualLabelUsageQuery } from '../../../../../store/apis/conceptual-label.api'
import { useThemeColors } from '../../../../../hooks/useThemeColors'

const { Title, Text } = Typography

const ConceptualLabelUsageTab = ({ conceptualLabelId }) => {
    const colors = useThemeColors()
    const { data: usageData, isLoading, error } = useFetchConceptualLabelUsageQuery(
        { conceptualLabelId },
        { skip: !conceptualLabelId }
    )

    if (isLoading) {
        return (
            <div style={{ textAlign: 'center', padding: 40 }}>
                <Spin size="large" />
            </div>
        )
    }

    if (error) {
        return (
            <Alert
                message="Error loading usage data"
                description="Unable to fetch conceptual label usage information."
                type="error"
                showIcon
            />
        )
    }

    if (!usageData || usageData.totalUsage === 0) {
        return (
            <Empty
                description={
                    <Space direction="vertical" size="small">
                        <Text>This conceptual label is not used yet</Text>
                        <Text type="secondary">
                            It hasn't been assigned to any patterns, groups, or categories.
                        </Text>
                    </Space>
                }
            />
        )
    }

    const usageSections = [
        {
            title: 'Patterns',
            count: usageData.patternsCount,
            description: 'Number of patterns using this conceptual label',
        },
        {
            title: 'Groups',
            count: usageData.groupsCount,
            description: 'Number of groups using this conceptual label',
        },
        {
            title: 'Categories',
            count: usageData.categoriesCount,
            description: 'Number of categories using this conceptual label',
        }
    ]

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <List
                dataSource={usageSections}
                renderItem={(section) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={section.icon}
                            title={
                                <Space>
                                    {section.title}
                                    <Badge 
                                        count={section.count} 
                                        showZero 
                                        color={section.count > 0 ? colors.primary : 'grey'}
                                    />
                                </Space>
                            }
                            description={section.description}
                        />
                    </List.Item>
                )}
            />
        </Space>
    )
}

export default ConceptualLabelUsageTab
